export default "__VITE_ASSET__D54vg2n8__"